import {
  Delineation,
  ServerDelineation,
} from '../../delineation/types/delineation.type';
import {
  Diagnostic,
  ServerDiagnostic,
} from '../../diagnostic/types/diagnostic';
import { Metric } from '../../metric/types/metric.type';
import { ServerWave } from '../../wave/types/wave.type';

export interface Ecg {
  id: string;
  analysisType: AnalysisType;
  dashboardMeasurements: Metric[];
  delineations: Delineation[];
  diagnostics: Diagnostic[];
  duration: number;
  recordType: RecordType;
  stripInfo?: HolterStripPayload;
  errorType?: string;
  patientInfo?: PatientInfoType;
}

export interface ServerFile {
  data: Record<string, number[]>;
  frequency: number;
  mV_per_unit: number;
}

export interface Pqrst {
  values: ServerWave[];
}

export interface ServerEcg {
  analysis_type: AnalysisType;
  dashboard_measurements: Metric[] | null;
  delineations: ServerDelineation[];
  diagnostics: ServerDiagnostic[];
  duration: number | null;
  filename: string;
  holter_strip_info?: ServerHolterStripInfo;
  record_type: RecordType;
  uuid: string;
  error_type: string | null;
  patient_info?: PatientInfoType;
}

export type RecordType = 'event' | 'holter' | 'resting' | 'rpm' | 'mct';

export type Pipeline =
  | 'event'
  | 'holter'
  | 'resting'
  | 'immutable'
  | 'internal';

export interface PatientInfoType {
  age?: number;
  sex?: string;
}

export interface AnalysisType {
  resting: boolean;
  event: boolean;
  holter: boolean;
  rpm: boolean;
  mct: boolean;
}

export interface EcgItem {
  id: string;
}

export interface ServerEcgItem {
  uuid: string;
  date: string;
  name: string;
}

export interface HolterStripPayload {
  parentId: string;
  start: number;
}

export interface HolterStripInfo {
  parentId: string;
  start: number;
  parentDuration: number;
}

export interface ServerHolterStripInfo {
  parent_uuid: string;
  start_time: number;
}

export type ParentHolter = Pick<Ecg, 'duration'>;

export const SexWordToLetterDict: Record<string, string> = {
  female: 'F',
  male: 'M',
};
